import {GET, POST, PUT, DELETE, reUrl} from '../../axiosconfig/axiosconfig'

export default {
    // 创建分享
    createShare: function (params) {
        return POST(reUrl + `/music/playlist/${params.id}/create_share/`, params)
    },

    // 获取分享列表
    listShares: function (params) {
        return GET(reUrl + `/music/playlist/${params.id}/list_shares/`, params)
    },

    // 访问分享的播放列表
    accessShared: function (params) {
        if (params.password) {
            // 如果有密码，使用POST请求
            return POST(reUrl + `/music/shared/${params.token}/`, params)
        } else {
            // 没有密码，使用GET请求
            return GET(reUrl + `/music/shared/${params.token}/`, params)
        }
    },

    // 复制分享的播放列表
    copyShared: function (params) {
        return POST(reUrl + `/music/shared/${params.token}/copy/`, params)
    },

    // 撤销分享
    deleteShare: function (params) {
        return DELETE(reUrl + `/music/playlist/share/${params.share_id}/`, params)
    },

    // 更新分享设置
    updateShare: function (params) {
        return PUT(reUrl + `/music/playlist/share/${params.share_id}/update/`, params)
    }
}
